import styled from 'styled-components';
import { InfoCardMiniSpan, CardInput, CardsList } from '../../CardInputs/CardsStyledComponents';
import { CardSection } from '../OptionsCards/PaymentCard/Detail/PaymentCardStyledComponents';

export const CardValues = styled.div``;

export const CardAmountInfoSection = styled(CardSection)`
  margin-top: 8px;
`;

export const SavedInfoText = styled(InfoCardMiniSpan)`
  @media (max-width: 650px) {
    display: none;
  }
`;

export const MobileSavedInfoText = styled(InfoCardMiniSpan)`
  display: none;

  @media (max-width: 650px) {
    display: flex;
  }
`;

export const CardInputCustomAmount = styled(CardInput)`
  flex-direction: column;
  width: 100%;
  padding: 0;
`;

export const CardInputPaymentPlan = styled(CardInput)`
  flex-direction: column;
  width: 100%;
  padding: 0;
  display: block;
`;

export const CardInputCustomPayment = styled(CardInput)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
`;

interface CardCustomPaymentSectionProps {
  $isSelected: boolean;
}

export const CardCustomPaymentSection = styled(CardSection) <CardCustomPaymentSectionProps>`
  gap: 10px;
  padding: ${(props) => (props.$isSelected ? '24px 24px 0' : '24px')};

  @media (max-width: 650px) {
    padding: 15px;
  }
`;

export const CoCardsList = styled(CardsList)`
  margin-bottom: 8px;
`;

export const CustomAmountTitle = styled.span``;

export const CustomAmountSubtitle = styled.span``;



export const MiniSpanContainer = styled.div`
 padding-right: 25px;
 padding-bottom: 10px;
 bottom: 10px;
 position: relative;
 display: grid;

  @media (max-width: 950px) and (min-width: 850px) {
    padding-right: 20px;
    bottom: 54px;
  }
    @media (max-width: 650px) {
    padding-right: 20px;
    padding-bottom: 20px;
    bottom: 0px;
  }

  @media (max-width: 420px) {
    margin-left: 52px;
    place-self: start;
  }

`;